import React from 'react';
import './AboutUs.css';

interface AboutUsProps {
  content: {
    title: string;
    description: string;
    contact: {
      address: string;
      email: string;
      phone: string;
    };
    social: {
      instagram: string;
      facebook: string;
      youtube: string;
    };
    mapUrl: string;
  };
}

const AboutUs: React.FC<AboutUsProps> = ({ content }) => {
  return (
    <div className="about-section" id="about">
      <div className="about-container section-header">
        <h2>{content.title}</h2>
        <div className="contact-grid">
          <div className="contact-info">
            <div className="contact-details">
              <p>
                <i className="fas fa-map-marker-alt"></i>
                <span>{content.contact.address}</span>
              </p>
              <p>
                <i className="fas fa-envelope"></i>
                <span>{content.contact.email}</span>
              </p>
              <p>
                <i className="fas fa-phone"></i>
                <span>{content.contact.phone}</span>
              </p>
            </div>
            
            <div className="social-links">
              <a href={content.social.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                <i className="fab fa-instagram"></i>
              </a>
              <a href={content.social.facebook} target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                <i className="fab fa-facebook"></i>
              </a>
              <a href={content.social.youtube} target="_blank" rel="noopener noreferrer" aria-label="YouTube">
                <i className="fab fa-youtube"></i>
              </a>
            </div>
          </div>

          <div className="map-container">
            <iframe
              src={content.mapUrl}
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Location Map"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutUs; 